var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cyber-news"},[_c('main-header'),_c('news-content'),_c('div',{staticClass:"cyber-news_others"},[_c('news-digest')],1),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }